import './_styles.scss';
import './_styles.dark-mode.scss';
import React, { useEffect, createContext, useReducer } from 'react';
import { Button } from 'react-bootstrap';
import arrayMove from 'array-move';

import FilterGroup from '../../../components/Filters/FilterGroup';
import ModalsManager from './components/Modals/Manager';
import Loader from '../../../components/Loaders/Loader';

import {
  ticketFormCategoryChangePosition,
  ticketFormChangePosition,
  ticketFormList,
} from '../../../services/endpoints/settings';
import Body from './components/Table/index'
import { createList, getListAfterStart } from './helpers';
import { mainReducer, mainState } from './reducer';
import {
  NEW_TICKET_INIT,
  NEW_TICKET_CHANGE_POSITION_START,
  NEW_TICKET_CHANGE_POSITION,
  NEW_TICKET_CHANGE_POSITION_STOP,
  NEW_TICKET_CLOSE_MODAL,
  NEW_TICKET_OPEN_MODAL,
  NEW_TICKET_ERROR, NEW_TICKET,
} from './reducer/actionTypes';
import { getErrorMessage } from '../../../utils/helper';
import { MODAL_ADD_CATEGORY } from './constants/modals';
import AlertComponent from '../../../components/Alert';

export const TicketContext = createContext({});
const NewTicket = () => {
  const [state, dispatch] = useReducer(mainReducer, mainState);
  const { mainList, sortedList, isLadingPage, isLoading, init, error, modal } = state;
  const fetchList = async () => {
    dispatch({
      type: NEW_TICKET,
      payload: {},
    })

    try {
      const response = await ticketFormList();
      const data = createList(response.data);
      dispatch({
        type: NEW_TICKET_INIT,
        payload: {
          data,
        },
      })
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      dispatch({
        type: NEW_TICKET_ERROR,
        payload: {
          error: errorMessage,
        },
      })
    }
  };

  useEffect(() => {
    fetchList();
    document.title = 'New ticket';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddCategory = () => {
    dispatch({
      type: NEW_TICKET_OPEN_MODAL,
      payload: {
        modalKey: MODAL_ADD_CATEGORY,
        data: {},
      },
    })
  }

  const fetchUpdatePosition = async () => {
    fetchList();
  }

  const handleSortEnd = async ({ oldIndex, newIndex, collection }, e) => {
    if (oldIndex === newIndex) {
      dispatch({
        type: NEW_TICKET_CHANGE_POSITION_STOP,
      })
      return;
    }

    const parentId = e.target.dataset?.parentId || null;

    switch (collection) {
    case 'level-0': {
      const list = arrayMove(mainList, oldIndex, newIndex);
      await ticketFormCategoryChangePosition({
        list: list.map((item) => item.id),
      });
      dispatch({
        type: NEW_TICKET_CHANGE_POSITION,
        payload: {
          list,
        },
      })
      break;
    }
    case 'level-1': {
      let subcategory = null;
      const list = mainList.map((item) => {
        if (Number(item.id) === Number(parentId)) {
          subcategory = arrayMove(item.children, oldIndex, newIndex)
          return {
            ...item,
            children: subcategory,
          }
        }
        return item;
      })
      if (subcategory) {
        await ticketFormChangePosition(parentId, {
          list: subcategory.map((item) => item.id),
        });
        dispatch({
          type: NEW_TICKET_CHANGE_POSITION,
          payload: {
            list,
          },
        })
      }
      break;
    }
    case 'level-2': {
      let field = null;
      const list = mainList.map((item) => ({
        ...item,
        children: item.children.map((subcategory) => {
          if (Number(subcategory.id) === Number(parentId)) {
            field = arrayMove(subcategory.children, oldIndex, newIndex);
            return {
              ...subcategory,
              children: field,
            }
          }
          return subcategory;
        }),
      }))
      if (field) {
        await ticketFormChangePosition(parentId, {
          list: field.map((item) => item.id),
        });
        dispatch({
          type: NEW_TICKET_CHANGE_POSITION,
          payload: {
            list,
          },
        })
      }
      break;
    }
    default:
      return null;
    }

    fetchUpdatePosition()
  };

  const handleSortStart = ({ node }) => {
    const { collection, parentIndex } = node.dataset;
    const listAfterStart = getListAfterStart(sortedList, collection, parentIndex)
    dispatch({ type: NEW_TICKET_CHANGE_POSITION_START,
      payload: {
        list: listAfterStart,
      } })
  };

  const onHide = () => {
    dispatch({ type: NEW_TICKET_CLOSE_MODAL })
  }

  const onSubmitModal = () => {
    dispatch({ type: NEW_TICKET_CLOSE_MODAL });
    fetchList();
  }

  if (isLadingPage) {
    return (
      <div className="loader-container" style={{ minHeight: '300px' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div className="settings-new-ticket">
      {isLoading && <div className="modal-loader" />}
      {error && <AlertComponent text={error} />}

      {init ? (
        <>
          <div>
            <FilterGroup>
              <Button className="pull-left add-btn" onClick={onAddCategory}>
                Add category
              </Button>
            </FilterGroup>
          </div>
          {sortedList.length
            ? (
              <div className="new-ticket">
                <TicketContext.Provider
                  value={{
                    ...state,
                    handleSortEnd,
                    handleSortStart,
                    dispatch,
                  }}
                >
                  <Body
                    items={sortedList}
                    handleSortEnd={handleSortEnd}
                    handleSortStart={handleSortStart}
                    parentId={null}
                  />
                </TicketContext.Provider>
              </div>
            ) : null }
        </>
      ) : null }
      <ModalsManager modal={modal} onHide={onHide} onSubmit={onSubmitModal} />
    </div>
  );
};

export default NewTicket;
